export enum BackendError {
  TOKEN = 'TOKEN',
  COMPANY = 'COMPANY',
  SHARED_VIEW = 'SHARED_VIEW',
  COMPANY_ALREADY_EXISTS = 'COMPANY_ALREADY_EXISTS',
}
